import CONSTANT from '../constant/common'
import CCONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import co from '../data/co'

const coValue = cookie(CCONSTANT.COOKIE_CO) || CONSTANT.COMMON_DEFAULT_CO

export let info = {
  a: co[coValue] ? co[coValue].agentId : co[CONSTANT.COMMON_DEFAULT_CO].agentId,
  ch: CONSTANT.COMMON_CHANNEL_ID,
  v: CONSTANT.COMMON_DEFAULT_VERSION,
  e: cookie(CCONSTANT.DEVICE_ID) || '1',
  cc: cookie(CCONSTANT.COOKIE_CPS_ID) || '',
  bc: cookie(CCONSTANT.COOKIE_V2_CITY_ID) || '0',
  la: '0',
  lo: '0'
}

// let customizedInfo = { ...info }
export const getCustomizedHeader = () => {
  return info
}

export const setCustomizedHeader = (cInfo) => {
  info = {
    ...info,
    ...cInfo,
  }
  // 值转化字符串
  for(let i in info) {
    info[i] = info[i]+''
  }
}
